import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom'
import { Spinner, Image } from 'react-bootstrap'
import Comment from '../CRUD/comment'
import Likes from '../CRUD/likes'
import DeletePost from '../CRUD/delete.post'
import Saved from '../CRUD/save'
import { auth } from '../../firebase/firebase-utils'
import Pagination from '../../Text-Editor/Pagination'

function MyPosts(props) {

    const [Query, setQuery] = useState([]);
    const [loader, setLoader] = useState(true);
    const [User, setUser] = useState(null)
    const [CurrentPage, setCurrentPage] = useState(1);
    const [currentPosts, setCurrentPosts] = useState([])
    const PostsPerPage = 10;

    useEffect(() => {
        auth.onAuthStateChanged(async user => {
            if (user && props.answers) {
                setQuery([])
                await setUser(user)
                var posts = [];
                props.posts.forEach(post => {
                    if (post.category === 'FEED') {
                        post.saved.map(item => {
                            if (item === user.uid) {
                                return posts.push(post)
                            } else { return null }
                        })
                    }
                    // for queries
                    else if (post.category === 'QUERY') {
                        // getting props.answers
                        if (props.answers) {
                            var list = props.answers;
                            list = list.filter(item => item.queryid === post.docid)
                            list = list.map(obj => {
                                var count = obj.saved.reduce((acc, ele) => {
                                    return ele === user.uid ? acc + 1 : acc
                                }, 0)
                                if (count !== 0) {
                                    return { ...obj, title: post.title }
                                } else { return 0 }
                            })
                            list = list.filter(item => item !== 0)
                            posts.push(...list)
                        }

                        console.log(posts)
                    }
                })

                if (posts.length !== 0) {
                    console.log(posts)
                    setQuery(posts)
                }
            }
        })

        setLoader(false)
    }, [props, User])

    useEffect(() => {
        //setting current posts
        const indexOfLastPost = CurrentPage * PostsPerPage;
        const indexOfFirstPost = indexOfLastPost - PostsPerPage;
        if (Query) {
            setCurrentPosts(Query.slice(indexOfFirstPost, indexOfLastPost))
        }
    }, [Query, CurrentPage])

    //setting current page
    const setCurrent = (e) => {
        setCurrentPage(e)
    }

    return (
        <div className="MyPosts">
            <h4 style={{ marginBottom: '30px', fontFamily: 'Poppins', margin: '0 10px' }}>SAVED POSTS :</h4>
            {loader || currentPosts === null ? <center><Spinner animation="border" variant="primary" /></center>
                :
                currentPosts.length === 0 ?
                    <center>
                        <h3>No Posts 😢</h3><br />
                        Add one by clicking on the floating '+' button in the bottom right corner
                    </center>
                    :
                    currentPosts.map((query) => (
                        <div key={query.docid}>
                            <div className="profile">
                                <Image src={query.userimage} />
                                <div>
                                    <p style={{ fontFamily: 'Poppins', fontSize: '14px', color: '#057BD0' }}>{query.username}
                                        <br /><span style={{ fontSize: '12px', fontFamily: 'Viga', color: 'gray' }}>{new Date(query.order).toISOString()}</span>
                                    </p>
                                </div>
                            </div>
                            <div className="cardDiv">
                                <h5>{query.title}</h5>
                                <div className="queryDescrip" dangerouslySetInnerHTML={{ __html: query.discrp }}></div>
                                <hr />
                                <div className="cardFooter">
                                    {
                                        query.title ?
                                            <>
                                                <p className="footerdiv" style={{ float: 'left' }}><DeletePost docid={query.docid} collection="answers" /></p>
                                                <p className="footerdiv"><Saved docid={query.docid} collection="answers" /></p>
                                                <p className="footerdiv"><Likes docid={query.docid} collection="answers" /></p>
                                            </>
                                            :
                                            <>
                                                <p className="footerdiv" style={{ float: 'left' }}><DeletePost docid={query.docid} collection="queries" /></p>
                                                <p className="footerdiv"><Saved docid={query.docid} collection="queries" /></p>
                                                <p className="footerdiv"><Likes docid={query.docid} collection="queries" /></p>
                                                <p className="footerdiv"><Comment docid={query.docid} collection="queries" /></p>
                                            </>
                                    }
                                </div>
                            </div>
                        </div>
                    ))
            }
             <div >
                {!Query ? null :
                    <Pagination totalPosts={Query.length} postsPerPage={PostsPerPage} setCurrentPage={setCurrent} />
                }
            </div>
        </div>
    )
}

export default withRouter(MyPosts);
